import { useEffect } from 'react';
import { useColors } from '../contexts/ColorContext';
import { useCms } from '../contexts/CmsContext';

/**
 * Hook para integrar os contextos de cores e CMS
 * Garante que as cores sejam aplicadas corretamente baseadas no contexto atual
 */
export const useCmsIntegration = () => {
  const { colors, loadExternalCmsData } = useColors();
  const { currentCms, isPersonalizedRoute } = useCms();

  useEffect(() => {
    // Se é uma rota personalizada e temos dados do CMS, aplicar as cores
    if (isPersonalizedRoute && currentCms) {
      // Carregar dados do CMS no ColorContext
      loadExternalCmsData({
        colors: currentCms.colors,
        cmsName: currentCms.cmsName,
        slug: currentCms.slug,
        logoUrl: currentCms.logoUrl
      });
    }
  }, [currentCms, isPersonalizedRoute, loadExternalCmsData]);

  return {
    colors,
    currentCms,
    isPersonalizedRoute
  };
};